import styled from 'styled-components';

export const Button = styled.button`
  margin: 0;
  padding: 0;
  background: none;
  border: none;
  outline: none;
`;
